import { useRef, useEffect, useCallback } from 'react';
import { VIRAL_LINK_POST_MESSAGES } from 'viral-links-lib/constants/EmbeddedViralLinks';
import { sendPostMessageToParent } from '../utils/postMessageUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApplicationWrapper = ({
  children
}) => {
  const applicationRef = useRef(null);
  const resizeParentFrame = useCallback(entries => {
    const applicationElement = entries[0].target;
    sendPostMessageToParent({
      action: VIRAL_LINK_POST_MESSAGES.SET_IFRAME_HEIGHT,
      value: `${applicationElement.offsetHeight}`
    });
  }, []);
  useEffect(() => {
    const divContainer = applicationRef.current;
    const resizeObserver = new ResizeObserver(resizeParentFrame);
    if (divContainer) {
      resizeObserver.observe(applicationRef.current);
    }
    return () => {
      resizeObserver.unobserve(divContainer);
    };
  }, [resizeParentFrame]);
  return /*#__PURE__*/_jsx("div", {
    ref: applicationRef,
    children: children
  });
};